import { Button } from 'components/atoms';
import { t } from 'i18next';
import { PiPlus, PiTrash } from 'react-icons/pi';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import DroppableAlbumTab, { Album } from './DroppableAlbumTab';

const AlbumTabs = ({
  albums,
  selectedAlbumNumber,
  onAlbumSelect,
  hoveredAlbum,
  onAddAlbum,
  onRemoveAlbum,
  displayMode,
}: {
  albums: Album[];
  selectedAlbumNumber: number;
  onAlbumSelect: (number: number) => void;
  hoveredAlbum: number | null;
  onAddAlbum: () => void;
  onRemoveAlbum: (albumNumber: number) => void;
  displayMode?: boolean;
}) => (
  <div className="flex justify-between items-center mb-4 z-10">
    <div className="flex flex-wrap gap-2 items-center">
      {albums.map((album) => (
        <DroppableAlbumTab
          key={album.albumNumber}
          album={album}
          isSelected={album.albumNumber === selectedAlbumNumber}
          onSelect={onAlbumSelect}
          isOver={hoveredAlbum === album.albumNumber}
        />
      ))}

      {!displayMode && (
        <div>
          <Button variant={BUTTON_VARIANT.white} onClick={onAddAlbum}>
            <Button.Icon icon={<PiPlus />} />
            {albums.length < 1 && <Button.Text text={t('button.add-album-first')} />}
          </Button>
        </div>
      )}
    </div>
    {!displayMode && albums.length > 1 && (
      <Button
        variant={BUTTON_VARIANT.remove}
        onlyIcon
        onClick={() => onRemoveAlbum(selectedAlbumNumber)}
        outsideChildren={<Button.Description description={t('button.remove-album')} />}
      >
        <Button.Icon icon={<PiTrash />} />
      </Button>
    )}
  </div>
);

export default AlbumTabs;
